// extracted by mini-css-extract-plugin
export default {"AreaChart":"apex-area-chart_AreaChart__NfdN9"};